import { render, staticRenderFns } from "./DrawStarSVG.vue?vue&type=template&id=580951ac&scoped=true&"
import script from "./DrawStarSVG.vue?vue&type=script&lang=js&"
export * from "./DrawStarSVG.vue?vue&type=script&lang=js&"
import style0 from "./DrawStarSVG.vue?vue&type=style&index=0&id=580951ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "580951ac",
  null
  
)

export default component.exports